const getApiUrl = () => {
  const API_SLUG = 'api';
  return `${window.location.protocol}//${window.location.host}/${API_SLUG}`;
};

export const API_URL = getApiUrl();
export const API_PROXY_URL = process.env.REACT_APP_PROXY_SERVER_URL;
export const BASE_PATH = '/app';
export const DRAWER_WIDTH = 256;
export const DRAWER_MINI_WIDTH = 72;
export const RAYGUN_UAT = '9HvjePtcJLCtQP3fluQ6w';
export const RAYGUN_PROD = 'NlmAAjwPawOXVUs5fDysig';

// If you are changing APP_VER please make sure to change X-APP-VERSION in
// app/views/partials/api/shared/api/headers.liquid
export const APP_VER = '4.1.0';

export const DOB_CONTACT_EMAIL = 'dob@dc.gov';
